// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"fbed52d8","9":"eac1a5c4","104":"6e5c78f1","819":"6a40252c","999":"471b2448"}[chunkId] + ".chunk.js";
};